import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import Message from "../../Components/Message";
import apiClient from "../../AppClient";
const SupplierModal = ({
  show,
  handleClose,
  mode,
  supplierData,
  refreshData,
}) => {
  const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(false);
  const [error, setError] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
  });

  useEffect(() => {
    if (supplierData) {
      setFormData(supplierData);
    } else {
      setFormData({ name: "", phone: "" });
    }
  }, [supplierData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleAddSupplier = async () => {
    // const url = `${process.env.REACT_APP_API_URL}/api/suppliers/create/`;
    setLoading(true);
    apiClient
      .post("/suppliers/create/", formData)
      .then((response) => {
        // alert("تمت الإضافة بنجاح!");
        refreshData();
        handleClose();
        setError(null);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
    setLoading(false);
    // try {
    //   await axios.post(url, formData, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   });
    //   alert("تمت الإضافة بنجاح!");
    //   refreshData();
    //   handleClose();
    // } catch (error) {
    //   const err = error.response.data.error;
    //   console.error("Error adding supplier:", err);
    //   setError(err);
    // }
  };

  const handleUpdateSupplier = async () => {
    // const url = `${process.env.REACT_APP_API_URL}/api/suppliers/${supplierData.id}/update/`;

    setLoading(true);
    apiClient
      .put(`/suppliers/${supplierData.id}/update/`, formData)
      .then((response) => {
        alert("تم التعديل بنجاح!");
        refreshData();
        handleClose();
        setError(null);
      })
      .catch((error) => {
        if (error.response) {
          setError(error.response.data.detail);
          setLoading(false);
        } else {
          setError("حدث خطأ اثناء الاتصال بالسيرفر");
          setLoading(false);
        }
      });
    setLoading(false);

    // try {
    //   await axios.put(url, formData, {
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //   });
    //   alert("تم التعديل بنجاح!");
    //   refreshData();
    //   handleClose();
    // } catch (error) {
    //   const err = error.response.data.error;
    //   console.error("Error updating supplier:", err);
    //   setError(err);
    // }
  };

  const handleSubmit = () => {
    if (mode === "add") {
      handleAddSupplier();
    } else {
      handleUpdateSupplier();
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className="modal-container flex-column-reverse" closeButton>
        {error && <Message variant="danger">{error} </Message>}
        <Modal.Title>
          {mode === "add" ? "إضافة مورد جديد" : "تعديل المورد"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="supplierName">
            <Form.Label>اسم المورد</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="أدخل اسم المورد"
            />
          </Form.Group>
          <Form.Group controlId="supplierPhone">
            <Form.Label>رقم الهاتف</Form.Label>
            <Form.Control
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="أدخل رقم الهاتف"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSubmit}>
          {mode === "add" ? "إضافة" : "تعديل"}
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          إلغاء
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SupplierModal;
